const CONTACT_FORM_ID = 'contact-form-v1';

export default function ContactSection() {
  return (
    <section id="contact" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-[720px] mx-auto">
          <div className="text-center mb-8 md:mb-10">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-2" style={{ fontFamily: 'var(--font-heading)' }}>
              联系投稿
            </h2>
            <p className="text-sm text-foreground-500">有好看的漫画推荐？遇到问题想反馈？欢迎联系我们</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5 mb-8">
            <div className="bg-background-100 rounded-xl p-5 text-center border border-background-200/70">
              <div className="w-10 h-10 mx-auto mb-3 rounded-xl bg-primary-100 flex items-center justify-center text-primary-600">
                <i className="ri-mail-line text-lg"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">投稿推荐</h3>
              <p className="text-xs text-foreground-500">发现好漫画想推荐给我们</p>
            </div>
            <div className="bg-background-100 rounded-xl p-5 text-center border border-background-200/70">
              <div className="w-10 h-10 mx-auto mb-3 rounded-xl bg-accent-100 flex items-center justify-center text-accent-600">
                <i className="ri-bug-line text-lg"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">问题反馈</h3>
              <p className="text-xs text-foreground-500">遇到阅读问题或Bug反馈</p>
            </div>
            <div className="bg-background-100 rounded-xl p-5 text-center border border-background-200/70">
              <div className="w-10 h-10 mx-auto mb-3 rounded-xl bg-secondary-100 flex items-center justify-center text-secondary-600">
                <i className="ri-hand-heart-line text-lg"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">合作洽谈</h3>
              <p className="text-xs text-foreground-500">商务合作与版权相关事宜</p>
            </div>
          </div>

          <div className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/70">
            <h3 className="text-sm font-semibold text-foreground-900 mb-4 text-center">发送消息</h3>
            <form
              id={CONTACT_FORM_ID}
              data-readdy-form=""
              className="space-y-4"
              onSubmit={async (e) => {
                e.preventDefault();
                const form = e.currentTarget;
                const honeypot = (form.querySelector('[name="website_alt"]') as HTMLInputElement)?.value?.trim();
                if (honeypot) return;

                const submitBtn = form.querySelector('button[type="submit"]') as HTMLButtonElement;
                const statusEl = document.getElementById('contact-form-status');
                if (submitBtn) submitBtn.disabled = true;

                try {
                  const formData = new FormData(form);
                  const response = await fetch('https://readdy.ai/api/form/d9k3q1ohpes2mi34sfrg', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
                  });
                  const responseText = await response.text();
                  let parsed;
                  try { parsed = JSON.parse(responseText); } catch { parsed = null; }

                  if (response.ok && parsed?.code === 'OK') {
                    if (statusEl) {
                      statusEl.textContent = '消息已发送，我们会尽快回复！';
                      statusEl.className = 'text-sm text-center mt-3 text-primary-600 font-medium';
                    }
                    form.reset();
                  } else {
                    const serverMsg = parsed?.meta?.message || parsed?.message || responseText;
                    if (statusEl) {
                      statusEl.textContent = serverMsg || '发送失败，请稍后重试';
                      statusEl.className = 'text-sm text-center mt-3 text-red-500 font-medium';
                    }
                  }
                } catch {
                  if (statusEl) {
                    statusEl.textContent = '网络错误，请稍后重试';
                    statusEl.className = 'text-sm text-center mt-3 text-red-500 font-medium';
                  }
                } finally {
                  if (submitBtn) submitBtn.disabled = false;
                }
              }}
            >
              <input
                type="text"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="honeypot-field"
              />
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label htmlFor="contact-name" className="block text-xs font-medium text-foreground-600 mb-1.5">昵称</label>
                  <input
                    type="text"
                    id="contact-name"
                    name="name"
                    required
                    className="w-full px-3 py-2.5 text-sm bg-background-50 border border-background-300 rounded-lg focus:outline-none focus:border-primary-400 transition-colors"
                    placeholder="你的昵称"
                  />
                </div>
                <div>
                  <label htmlFor="contact-email" className="block text-xs font-medium text-foreground-600 mb-1.5">邮箱</label>
                  <input
                    type="email"
                    id="contact-email"
                    name="email"
                    required
                    className="w-full px-3 py-2.5 text-sm bg-background-50 border border-background-300 rounded-lg focus:outline-none focus:border-primary-400 transition-colors"
                    placeholder="your@email.com"
                  />
                </div>
              </div>
              <div>
                <label htmlFor="contact-type" className="block text-xs font-medium text-foreground-600 mb-1.5">类型</label>
                <select
                  id="contact-type"
                  name="type"
                  className="w-full px-3 py-2.5 text-sm bg-background-50 border border-background-300 rounded-lg focus:outline-none focus:border-primary-400 transition-colors"
                >
                  <option value="recommend">漫画推荐</option>
                  <option value="feedback">问题反馈</option>
                  <option value="business">合作洽谈</option>
                  <option value="other">其他</option>
                </select>
              </div>
              <div>
                <label htmlFor="contact-message" className="block text-xs font-medium text-foreground-600 mb-1.5">留言内容</label>
                <textarea
                  id="contact-message"
                  name="message"
                  required
                  maxLength={500}
                  rows={4}
                  className="w-full px-3 py-2.5 text-sm bg-background-50 border border-background-300 rounded-lg focus:outline-none focus:border-primary-400 transition-colors resize-none"
                  placeholder="写下你想说的话...（最多500字）"
                ></textarea>
              </div>
              <div className="text-center">
                <button
                  type="submit"
                  className="inline-flex items-center gap-2 px-6 py-2.5 bg-primary-500 text-background-50 rounded-lg font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-send-plane-line"></i>
                  发送消息
                </button>
              </div>
              <div id="contact-form-status"></div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}